import React, { FC } from 'react'
import cx from 'classnames'

import { Image } from '../../types'
import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type HeaderProps = {
  className?: string
  logo: Image & { logoLink?: string }
  text: string
  action: ActionButtonProps
}

const Header: FC<HeaderProps> = (props) => {
  const { className, logo, text, action } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.DefaultLink href={logo?.logoLink}>
        <SC.Logo src={logo.src} alt={logo.alt} />
      </SC.DefaultLink>
      <SC.Text>{text}</SC.Text>
      <SC.Button {...action} />
    </SC.Container>
  )
}

export default Header
